import { START_DOWNLOAD, UPDATE_DOWNLOAD, DOWNLOAD_PROGRESS, DOWNLOAD_COMPLETE, UNDO_DOWNLOAD } from '@/redux/actions/socket.actions'
import { LOGOUT } from '@/redux/actions/auth.actions'
import Toggles from '@domain/toggles/Toggles'

const initalState = {
	download: {
		progress: {},
		response: '',
		downloading: false,
		showInfo: false
	}
}

const download = (state = initalState.download, action) => {
	switch (action.type) {
		case START_DOWNLOAD:
			return { ...state, ...action.payload }

		case UPDATE_DOWNLOAD:
			return {
				...state,
				response: action.payload?.response,
				downloading: action.payload?.downloading,
				showInfo: action.payload?.showInfo || state.showInfo
			}

		case DOWNLOAD_PROGRESS:
			if (Toggles.isEnabled('docsWebV2')) {
				const newProgresses = {...action.payload}
				// Ignore updates that don't increase or fail the progress
				for(const key in newProgresses){
					if(state.progress[key]?.currentProgress > newProgresses[key]?.currentProgress && newProgresses[key].currentProgress !== 3){
						delete newProgresses[key]
					}
				}
				return {
					...state,
					progress: {
						...state.progress,
						...newProgresses
					}
				}
			} else {
				return {
					...state,
					showInfo: true,
					...{
						progress:
							Object.keys(state.progress).length !== 0
								? {
									...state.progress,
									...Object.entries(action.payload).reduce(
										(acc, [key, value]) => ({
											...acc,
											...(Object.keys(state.progress).includes(key) && { [key]: value })
										}),
										{}
									)
								}
								: action.payload
					}
				}
			}
		case DOWNLOAD_COMPLETE:
			const progress = JSON.parse(JSON.stringify(state.progress))
			for (const fileProgress of Object.values(progress)) {
				if(fileProgress.currentProgress !== 3)
					fileProgress.currentProgress = fileProgress.totalProgress
			}

			return { ...state, progress }
		case UNDO_DOWNLOAD:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return {
				progress: {},
				response: '',
				downloading: false,
				showInfo: false
			}

		default:
			return state
	}
}

export default {
	name: 'socket',
	reducers: {
		download
	}
}
